<template>
  <div class="gluTable-ctn" :style="{ zoom: zoomRatio }">
    <div :id="`wtgluTable_2_${id}`" :style="{ width: w + 'px', height: h2 + 'px'}">
    </div>
    <div :id="`wtgluTable_${id}`" :style="{ width: w + 'px', height: h1 + 'px'}">
    </div>
    <div class="legend legend--row1">
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="legend-bg-value" />
        </template>
        {{ $t('BG Value') }}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="legend-aidex-value" />
        </template>
        {{ $t('AiDEX Value') }}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="legend-cgm-value" />
        </template>
        {{ $t('CGMs Value') }}
      </wt-legend>      
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="legend-pump-value" />
        </template>
        {{ $t('Pump Value') }}
      </wt-legend>           
      <wt-legend class="legend-diamondCtn">
        <template slot="icon">
          <svg-icon icon-class="legend-diamond" />
        </template>
        {{ $t('diamond in the middle of 2 hours range') }}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="legend-low" />
        </template>
        {{ $t('Threshold of low BG') }}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="legend-high" />
        </template>
        {{ $t('Threshold of high BG') }}
      </wt-legend>      
    </div>    
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import wtLegend from '@c/Legend'
import dayjs from 'dayjs'
import $ from 'jquery'
import * as d3 from 'd3'
import { qcopy, isHighGlu, isLowGlu } from '@u'
import { SVG, _appendRoundedCorners } from '@u/reportHelper'
import { errorFactory, derrorFactory, dlogFactory } from '@u/log'
const error = errorFactory('ChartGluTable', false)
const derror = derrorFactory('ChartGluTable', true)
const log = dlogFactory('ChartGluTable', true)

let _id = 1

function _moveToToday(time) { // x轴是Today
  const today = dayjs() // 是为了能在dayjs时区变换后能相应体现，所以在这里再次声明一个startOfDay，而不是放到一个全局的地方声明好了，就不动了(复用)
  const origin = dayjs(time)
  
  const news = `${today.format('YYYY-MM-DD')} ${origin.format('HH:mm:ss')}`
  const rst = +dayjs(news)
  // derror(`_moveToToday, time: ${time}, rst: ${news}, number: ${rst}`)
  return rst
}

function _tableLineData(base = 23, alldata = [], maxValue = 0, unitRatio = 1) {
  derror(`_tableLineData, base: ${base}`)
  const nowT = dayjs()
  const startOfDay = nowT.startOf('day') // 是为了能在dayjs时区变换后能相应体现，所以在这里再次声明一个startOfDay，而不是放到一个全局的地方声明好了，就不动了(复用)  
  
  const calCount = +base === (maxValue - 0 + 1 * unitRatio) // 这一行是算次数
  
  const rst = []
  for (let i = 0; i < 24; i++) {
    const startTime = startOfDay.add((i * 60), 'minute')
    const endTime = startTime.add(60, 'minute')
    const halfTime = startTime.add(30, 'minute')
    // derror(`alldata: `, alldata)
    const filtered = alldata.filter(d => {
      const $d = _moveToToday(dayjs(d.appTime))
      
      const stay = ($d - startTime >= 0) && ($d - endTime < 0)
      return stay
    })
    // derror(`filtered: `, filtered)
    
    if (calCount) {
      rst.push([
        +halfTime,
        base,
        filtered.length,
        +startTime,
        +endTime
      ])
    } else {
      // 计算平均值
      const sum = filtered.reduce((prev, cur) => {
        return +prev + (cur.bloodGlucose)
      }, 0)
      
      const average = filtered.length > 0 ? ((sum / filtered.length).toFixed(1)) : 0
      rst.push([
        +halfTime,
        base,
        average
      ])
    }
  }
  return rst
}
function _halftime(d) {
  const before = dayjs(d)
  const startOfHour = before.startOf('hour')
  const after = startOfHour.add(30, 'minute')
  return after
}
function _day1ToDay2LineSerires(isUnitMg, day1Data, day2Data, extra = {}) {
  const { cmaxC, cminC, normalC } = extra
  const todayStart = dayjs().startOf('day')
  
  if (!day1Data || !day2Data || !day1Data.length || !day2Data.length) return []
  
  const _seriesCom = {
    name: 'day1ToDay2Line',
    type: 'line',
    lineStyle: {
      color: '#999',
      width: 1,
      type: 'dashed'
    },
    label: {
      show: false
    },
    symbol: '',
    data: [],
    itemStyle: {
      color: 'functionPlaceHolder'
    }
  }
  
  const day1Last = day1Data[day1Data.length - 1]
  const day2First = day2Data[0]
  if (!day1Last || !day2First) {
    return []
  }
  
  const day1LastV = _getValue(day1Last)
  const day2FirstV = _getValue(day2First)
  const day1LastT = _getTimeOffsetToday(day1Last)
  const day2FirstT = _getTimeOffsetToday(day2First)
  const gapT = dayjs(day2FirstT).add(1, 'day') - day1LastT
  const gapV = day2FirstV - day1LastV
  const day1LastTToDayEndGap = todayStart.add(1, 'day') - day1LastT
  const ratio = day1LastTToDayEndGap / gapT
  const crossPointV = day1LastV + (gapV * (ratio))
  // step1, day1的结束连线
  const s1 = Object.assign({}, _seriesCom, { name: 'day1ToDay2LineS1_' + +day1LastT })
  const endPoint = [
    +todayStart.endOf('day'),
    isUnitMg ? crossPointV.toFixed(0) : crossPointV.toFixed(1),
    crossPointV
  ]
  s1.data = [day1Last, endPoint]
  s1.itemStyle.color = _itemStyleColor
  // step2, day2开始的连线
  const s2 = Object.assign({}, _seriesCom, { name: 'day1ToDay2LineS1_' + +day2FirstT })
  const startPoint = [
    +todayStart,
    isUnitMg ? crossPointV.toFixed(0) : crossPointV.toFixed(1),
    crossPointV
  ]
  s2.data = [startPoint, day2First]
  s2.itemStyle.color = _itemStyleColor
  
  return [s1, s2]
  
  function _getValue(one) {
    if (one && one.length >= 2) {
      return +one[1]
    } else {
      return 0
    }
  }
  function _getTimeOffsetToday(one) {
    if (one && one.length >= 2) {
      return one[0]
    } else {
      return +todayStart
    }
  }
  function _itemStyleColor(params) {
    const { data = [] } = params || {}
    const v = data[1]
    let rst = normalC
    if (isHighGlu(v)) {
      rst = cmaxC
    } else if (isLowGlu(v)) {
      rst = cminC
    }
    return rst
  }
}
export default {
  name: 'CChartGluTable',
  components: {
    wtLegend
  },
  mixins: [reDrawTrigger],
  props: {
    noMealHighlight: {
      type: [Boolean],
      default: false
    },
    noHorizontalSplitLine: {
      type: [Boolean],
      default: false
    },
    setting: {
      type: [Object],
      default: () => {
        return {}
      }
    },
    values: {
      type: [Array],
      default: () => []
    },
    diamonds: {
      type: [Array],
      default: () => []      
    }
  },
  data() {
    _id++
    const id = `cglutable_${+new Date()}_${_id}`
    return {
      id
    }
  },
  computed: {
    w() {
      const ds = this.ds
      return Math.round(ds * (1186 / 1740))
    },
    h() {
      const w = this.w
      const r = 619 / 1186
      return Math.round(r * w)
    },
    h2() { // 两行table的高
      const { h } = this
      return (84 / 624) * h
    },
    h1() {
      const { h } = this
      return (540 / 624) * h
    }
  },
  mounted() {
    this.rendergluTables(false)
    // this.renderLegends(false)
  },
  // watch: {
  //   values(nv) {
  //     derror(`[chartglutable]values, 数据变换, 新数据nv: `, nv)
  //     // this.refreshTriggered()
  //   }
  // },
  methods: {
    getCommonMealBgHighlight() {
      const { noMealHighlight } = this
      if (noMealHighlight) { // 早、中、晚餐的类似label的东西
        // 不显示三餐高亮
        return []
      }
      const {
        mealLabelOffsets
      } = this.getUiParams()    
      const nowT = dayjs()
      const startOfDay = nowT.startOf('day') // 是为了能在dayjs时区变换后能相应体现，所以在这里再次声明一个startOfDay，而不是放到一个全局的地方声明好了，就不动了(复用)  
      // 高亮早、中、晚餐部分
      const rst = { // 高亮早、中、晚餐部分
        name: '高亮三餐',
        type: 'line',
        data: [],
        lineStyle: {
          width: 2
        },
        symbol: 'none',
        smooth: true,
        markArea: {
          itemStyle: {
            color: 'rgba(243, 178, 69, 0.23)',
            borderColor: '#abccba',
            borderWidth: 0
          },
          data: [
            [{ xAxis: +startOfDay.add(mealLabelOffsets.breakfast.start, 'hour') }, { xAxis: +startOfDay.add((+mealLabelOffsets.breakfast.start + +mealLabelOffsets.breakfast.duration), 'hour') }],
            [{ xAxis: +startOfDay.add(mealLabelOffsets.lunch.start, 'hour') }, { xAxis: +startOfDay.add((+mealLabelOffsets.lunch.start + +mealLabelOffsets.lunch.duration), 'hour') }],
            [{ xAxis: +startOfDay.add(mealLabelOffsets.supper.start, 'hour') }, { xAxis: +startOfDay.add((+mealLabelOffsets.supper.start + +mealLabelOffsets.supper.duration), 'hour') }]
          ]
        }
      }
      return [rst]
    },
    getCommonXaxis(what = 'top') {
      const { cmax, cmaxC, cmin, cminC, normalC, stripeBgC, stripeInnerBorderC, lfw, lfs, largerRatio, unit, ds } = this
      const _isBottom = `${what}` === 'bottom'
      const nowT = dayjs()
      const startOfDay = nowT.startOf('day')
      const rst = {
        boundaryGap: false,
        type: 'time',
        // data: hours,
        splitLine: {
          show: true,
          lineStyle: {
            color: stripeInnerBorderC                
          }
        },
        splitArea: {
          show: true,
          areaStyle: {
            // 使用深浅的间隔色
            color: [stripeBgC, 'white'],
          },
        },
        splitNumber: 12,
        min: +dayjs().startOf('day'),
        max: +dayjs().add(1, 'day').startOf('day'),
        axisLine: {
          show: _isBottom,
          lineStyle: {
            color: 'black',
            width: 1
          }
        },
        axisTick: {
          show: _isBottom,
          color: 'black'
        },
        axisLabel: {
          show: _isBottom,
          showMaxLabel: true,
          color: 'black',
          formatter: (v, i) => {
            const rst = dayjs(v).format('HH:mm')
            log(`v: ${rst}, i: ${i}`)
            if (i % 2 === 1) { // 用来控制label隔一个显示
              if (i > 1 && `${rst}` === '00:00') {
                return '24:00'
              }
              return rst
            } else {
              return ''
            }
          }
        }
      }
      
      const rst2 = { // x轴的线，要压过y轴的splitLine的线，因为要显示出x轴的黑色
        z: 3,
        boundaryGap: false,
        type: 'time',
        // data: hours,
        splitLine: {
          show: true,
          lineStyle: {
            color: stripeInnerBorderC                
          }
        },
        splitArea: {
          show: true,
          areaStyle: {
            // 使用深浅的间隔色
            color: [stripeBgC, 'white'],
          },
        },
        axisLine: {
          show: _isBottom,
          lineStyle: {
            color: 'black',
            width: 1
          }
        }
      }
      
      return [rst, rst2]
    },
    getSeriesFromDataSource(what) {
      const { cmax, cmaxC, cmin, cminC, normalC, stripeBgC, stripeInnerBorderC, lfw, lfs, largerRatio, unit, ds, values = [], unitRatio = 1, isUnitMg } = this
      const nowT = dayjs()
      const startOfDay = nowT.startOf('day')
      
      const labelCom = {
        fontSize: lfs - 2,
        padding: [1, 1, 1, 1],
        borderRadius: [2, 2, 2, 2]
      }
      
      const _seriesCom = {
        name: 'circle',
        type: 'line',
        lineStyle: {
          color: 'rgba(56, 56, 56, 1)',
          width: 1,
          type: 'solid'
        },
        label: { // 数值、矩形底
          show: false,
          position: 'right',
          color: 'white',
          offset: [-2, 0],
          formatter: 'functionPlaceHolder',
          rich: {
            normal: Object.assign({}, labelCom, {
              backgroundColor: normalC,
            }),
            max: Object.assign({}, labelCom, {
              backgroundColor: cmaxC
            }),
            min: Object.assign({}, labelCom, {
              backgroundColor: cminC
            })
          },
        },
        symbol: '',
        symbolKeepAspect: true, // 否则symbol为'path://'的代码，会被拉伸，导致出来的效果图不是想要的，从而卡在这里
        symbolSize: 8,
        itemStyle: {
          color: 'functionPlaceHolder'
        },
        data: []
      }
      
      const series = []
      
      const _ds = this.values || []
      const _counts = _tableLineData(1 * unitRatio, _ds, 0, unitRatio)
      const _tmpDiamonds = this.diamonds || []
      const _diamonds = _tmpDiamonds
      const _diamondsIgnoreIndexes = []
      _tmpDiamonds.forEach((v, i) => {
        // _tmpDiamonds 12条数据, _counts 24条数据
        const countI0 = i * 2
        const countI1 = i * 2 + 1
        //   counts 每一项: [
        //     +halfTime,
        //     base,
        //     filtered.length,
        //     +startTime,
        //     +endTime
        // ]
        const c0 = _counts[countI0]
        const c1 = _counts[countI1]
        const num0 = Number.isNaN(+c0[2]) ? 0 : +c0[2]
        const num1 = Number.isNaN(+c1[2]) ? 0 : +c1[2]
        const sum = num0 + num1
        if (sum - 1 <= 0) {
          _diamondsIgnoreIndexes.push(i)
        }
      })
      
      // derror(`[ChartGluTable]${what},getSeriesFromDataSource,_ds`, _ds)
      
      // diamonds画图
      const _diamondS = qcopy(_seriesCom)
      _diamondS.name = 'diamonds'
      _diamondS.lineStyle.width = 0
      _diamondS.label.show = false
      _diamondS.symbolSize = 20
      _diamondS.symbol = `path://<path d="M8, 0l8, 8l-8, 8l-8 -8Z" fill="red"></path>`
      
      // _diamondS.symbol = `circle`
      _diamondS.itemStyle.color = 'black'
      _diamondS.data = (Array.from({ length: 12 }, (v, i) => {
        const rst = [
          +startOfDay.add((1 + i * 2), 'hour'),
          _diamonds[i]
        ]
        if (_diamondsIgnoreIndexes.includes(i)) {
          rst[2] = true // ignore
        }
        return rst
      })).filter(v => v && v[1] && !v[2]) // 过滤掉，只画有值的diamond; v[2]为是否ignore
      series.push(_diamondS)
      
      const _days = {}
      const _lineFromDay1ToDay2 = []
      
      // 按日期分类
      _ds.forEach(d => {
        const f = 'YYYY-MM-DD'
        const $d = dayjs(d.appTime)
        const day = $d.format(f)
        
        if (_days[day] === undefined) {
          _days[day] = []
        }
        
        _days[day].push(d)
      })
      const tmpDates = (Object.keys(_days).sort((date1, date2) => dayjs(date1) - dayjs(date2)))
      const tmpDatesL = tmpDates.length
      tmpDates.forEach((key, i) => {
        const data = _days[key] || []
        const next = (i + 1 - tmpDatesL >= 0) ? null : (_days[tmpDates[i + 1]] ? _days[tmpDates[i + 1]] : [])
        
        const tmpSeriesDataOrdered = (_dataConverter(data)).sort((first, second) => first[0] - second[0])
        const nextOrdered = next ? ((_dataConverter(next)).sort((first, second) => first[0] - second[0])) : null
        // 生成series
        const _s1 = Object.assign({}, qcopy(_seriesCom), {
          data: tmpSeriesDataOrdered,
          name: `day${key}`
        })
        const _day1ToDay2S = _day1ToDay2LineSerires(isUnitMg, tmpSeriesDataOrdered, nextOrdered, { cmaxC, cminC, normalC }) // 返回值是个数组
        
        _s1.label.formatter = _labelFormatter
        _s1.itemStyle.color = _itemStyleColor
        _s1.symbol = _symbolFormatter
        series.push(_s1)
        if (_day1ToDay2S && _day1ToDay2S.length) { // 第一天和第二天的连线
          series.push(..._day1ToDay2S)
        }
      })
      
      derror(`[ChartGluTable]${what},series: `, series)
      // derror(`series: ${JSON.stringify(series)}`)
      return series
      
      function _dataConverter(data) {
        return data.map((d, i) => [
          _moveToToday(d.appTime),
          isUnitMg ? (+d.bloodGlucose).toFixed(0) : (+d.bloodGlucose).toFixed(1),
          d.dataOrigin
        ])        
      }
      
      function _labelFormatter(params = {}) {
        const { data = [] } = params
        // derror(`formatter, v: ${JSON.stringify(v)}, params: ${params}`)
        const v = data[1]
        let what = 'normal'
        
        if (isHighGlu(v)) {
          what = 'max'
        } else if (isLowGlu(v)) {
          what = 'min'
        }
        return `{${what}|${v}}`
      }
      
      function _symbolFormatter(data = []) {
        const _d = ''
        // derror(`_symbolFormatter, data:`, data)
        let what = data[2] // 是数字; 0: pump, 1: bg, 2: aidex;3:cgm
        const _w = what
        derror(`_symbolFormatter, what:`, what)
        if (what === undefined) {
          what = _d
        } else {
          // const _map = ['emptytriangle', 'emptycircle', 'emptyrect'] // pump, bg, aidex
          // const _map = ['triangle', 'circle', 'rect'] // pump, bg, aidex
          const _map = ['', 'circle', 'rect', 'cgm'] // pump, bg, aidex;cgm
          
          what = _map[what]
          if (what === undefined) {
            what = _d
          }
          
          if (`${_w}`.trim() === '0') { // pump
            // what = `path://<line x1="0.5" y1="0.5" x2="0.5" y2="8.5" id="直线-10"></line>`
            what = `path://M28,28 l-6,0 l0,-28 l6,0 l0,28`
            // what = `path://M28,28l-4,0l0,-28l4,0l0,28Z` 
            // what = `path://M29.5,9 L28.5,9 L28.5,5 L1.5,5 L1.5,9 L0.5,9 L0.5,0 L1.5,0 L1.5,4 L28.5,4 L28.5,0 L29.5,0 L29.5,9 Z`
            // what = 'emptycircle3'
          }
        }
        derror(`_symbolFormatter, rst: ${what}`)
        return what
      }
      
      function _itemStyleColor(params) {
        const { data = [] } = params || {}
        const v = data[1]
        let rst = normalC
        if (isHighGlu(v)) {
          rst = cmaxC
        } else if (isLowGlu(v)) {
          rst = cminC
        }
        return rst
      }
    },
    alterAfterEchartsRendered(isUpdate) { // echarts的底部。左下角和右下角的rounded corner
      const { id, ds, stripeInnerBorderC } = this
      const {
        oneHourW, mealLabelOffsetX, mealLabelOffsetY, mealLabelOffsetH, mealLabelRoundedCornerW, mealLabelOffsets, grid
      } = this.getUiParams()
      
      const $g = $(`#wtgluTable_${id} svg > g`)
      
      /* *********echarts坐标轴图表的四角rounded********* */
      if (!isUpdate) {
        const { left, bottom, top, right } = grid
        const { w, h1: h } = this
        const topLeftCorner = {
          x: left,
          y: top
        }
        const bottomRightCorner = {
          x: w - right,
          y: h - bottom
        }
        
        const radiusW = 12
        _appendRoundedCorners($g, {
          borderColor: stripeInnerBorderC,
          id: `${id}_echarts_rcorners_bottomleft`,
          w: radiusW,
          offsetX: topLeftCorner.x,
          offsetY: bottomRightCorner.y,
          isLeft: true,
          isTop: false
        })
        
        _appendRoundedCorners($g, {
          borderColor: stripeInnerBorderC, 
          id: `${id}_echarts_rcorners_bottomright`,
          w: radiusW,
          offsetX: bottomRightCorner.x,
          offsetY: bottomRightCorner.y,
          isLeft: false,
          isTop: false
        })
      }
      /* *********End of echarts坐标轴图表的四角rounded********* */      
    },
    alterAfterEchartsRendered2RowTable(isUpdate) { // echarts的上部。左上角和右上角的rounded corner && 三餐的矩形label做一个圆角的效果(rounded corner)
      const { id, ds, stripeInnerBorderC, noMealHighlight, setting = {}} = this
      const {
        oneHourW, mealLabelOffsetX, mealLabelOffsetY, mealLabelOffsetH, mealLabelRoundedCornerW, mealLabelOffsets, grid2RowTable: grid
      } = this.getUiParams()
      
      const $g = $(`#wtgluTable_2_${id} svg > g`)
      
      /* *********echarts坐标轴图表的四角rounded********* */
      if (!isUpdate) {
        const { left, bottom, top, right } = grid
        const { w, h2: h } = this
        const topLeftCorner = {
          x: left,
          y: top
        }
        const bottomRightCorner = {
          x: w - right,
          y: h - bottom
        }
        
        const radiusW = 12
        _appendRoundedCorners($g, {
          borderColor: stripeInnerBorderC,
          id: `${id}_echarts_rcorners_topleft`,
          w: radiusW,
          offsetX: topLeftCorner.x,
          offsetY: topLeftCorner.y,
          isLeft: true
        })
        _appendRoundedCorners($g, {
          borderColor: stripeInnerBorderC, 
          id: `${id}_echarts_rcorners_topright`,
          w: radiusW,
          offsetX: bottomRightCorner.x,
          offsetY: topLeftCorner.y,
          isLeft: false
        })
      }
      /* *********End of echarts坐标轴图表的四角rounded********* */
      
      if (noMealHighlight) { // 早、中、晚餐的类似label的东西
        // 不需要显示三餐高亮
        // 不再给三餐label做圆角
        return
      }
      /* ++++++++++breakfast的圆角++++++++++ */
      if (!isUpdate && setting.settingId !== undefined) {
        const { start, duration } = mealLabelOffsets.breakfast
        const w = mealLabelRoundedCornerW
        _appendRoundedCorners($g, {
          id: `${id}_mealLabel_bf_left`,
          w, start, durationW: duration * oneHourW, offsetX: start * oneHourW + mealLabelOffsetX, offsetY: mealLabelOffsetY, isLeft: true
        })
        _appendRoundedCorners($g, {
          id: `${id}_mealLabel_bf_right`,
          w, start, durationW: duration * oneHourW, offsetX: start * oneHourW + mealLabelOffsetX, offsetY: mealLabelOffsetY, isLeft: false
        })
      } else {
        // 目前是do nothing，以后可以根据id，获取到圆角的path之后，将path进行transform的位移(因为大概率是标签开始时间、持续时间进行变更->update)
      }
      /* ++++++++++End of breakfast的圆角++++++++++ */
      
      /* *********Lunch的圆角********* */
      if (!isUpdate && setting.settingId !== undefined) {
        const { start, duration } = mealLabelOffsets.lunch
        const w = mealLabelRoundedCornerW
        _appendRoundedCorners($g, {
          id: `${id}_mealLabel_l_left`,
          w, start, durationW: duration * oneHourW, offsetX: start * oneHourW + mealLabelOffsetX, offsetY: mealLabelOffsetY, isLeft: true
        })
        _appendRoundedCorners($g, {
          id: `${id}_mealLabel_l_right`,
          w, start, durationW: duration * oneHourW, offsetX: start * oneHourW + mealLabelOffsetX, offsetY: mealLabelOffsetY, isLeft: false
        })
      } else {
        // 目前是do nothing，以后可以根据id，获取到圆角的path之后，将path进行transform的位移(因为大概率是标签开始时间、持续时间进行变更->update)
      }
      /* *********End of Lunch的圆角********* */
      
      /* ++++++++++Supper的圆角++++++++++ */
      if (!isUpdate && setting.settingId !== undefined) {
        const { start, duration } = mealLabelOffsets.supper
        const w = mealLabelRoundedCornerW
        _appendRoundedCorners($g, {
          id: `${id}_mealLabel_s_left`,
          w, start, durationW: duration * oneHourW, offsetX: start * oneHourW + mealLabelOffsetX, offsetY: mealLabelOffsetY, isLeft: true
        })
        _appendRoundedCorners($g, {
          id: `${id}_mealLabel_s_right`,
          w, start, durationW: duration * oneHourW, offsetX: start * oneHourW + mealLabelOffsetX, offsetY: mealLabelOffsetY, isLeft: false
        })
      } else {
        // 目前是do nothing，以后可以根据id，获取到圆角的path之后，将path进行transform的位移(因为大概率是标签开始时间、持续时间进行变更->update)
      }
      /* ++++++++++End of Supper的圆角++++++++++ */      
    },
    refreshTriggered() {
      derror(`ChargluTable ${this.id}, this.refreshTriggered`)
      this.rendergluTables(true)
      // this.renderLegends(true)
    },
    // renderLegends(isUpdate = false) {
    //   const { id, cmaxC, cminC } = this
    //   // derror(`id: ${id}`)
    //   const legendId = `wtgluTable_l_${id}`
    //   const $legend = d3.select(`#${legendId}`)
    //   const svgId = `wtgluTable_l_svg_${id}`
    
    //   const svg = isUpdate ? $legend.select(`#${svgId}`) : $legend.append('svg')
    
    //   svg.attr('width', 500)
    //     .attr('height', 40)
    
    //   if (!isUpdate) {
    //     svg.attr('id', svgId)
    //   }
    
    //   const gId = `wtgluTable_l_svg_g_${id}`
    //   const chartG = isUpdate ? svg.select(`#${gId}`) : svg.append('g')
    //   if (!isUpdate) { // 第一次(init)
    //     chartG.attr('id', gId)
    //   }
    
    //   const textW = 10
    //   const y = 10
    
    //   chartG.selectAll('text')
    //     .data([
    //       {
    //         text: '------',
    //         x: 2 * textW,
    //         y,
    //         fontWeight: '600',
    //         color: cminC
    //       },
    //       {
    //         text: this.$t('Threshold of low BG'),
    //         color: '#333',
    //         x: 6 * textW,
    //         y
    //       },
    //       {
    //         text: '------',
    //         fontWeight: '600',
    //         color: cmaxC,
    //         x: 18 * textW,
    //         y
    //       },
    //       {
    //         text: this.$t('Threshold of high BG'),
    //         color: '#333',
    //         y,
    //         x: 22 * textW
    //       }
    //     ])
    //     .join('text')
    //     .join('text')
    //     .text(d => d.text)
    //     .attr('font-size', d => `${d.fs ? d.fs : 10}`)
    //   // .attr('style', d => `text-anchor: ${d.anchor ? d.anchor : 'end'}`)
    //     .attr('x', d => {
    //       return d && d.marginLeft ? (d.x - 0 + 10) : d.x
    //     })
    //     .attr('y', d => d.y)
    //     .attr('fill', d => d.color)
    // },
    rendergluTables(isUpdate = false) {
      // /* ++++++++++给表格顶部的三餐标签做一个圆角++++++++++ */
      // setTimeout(() => {
      //   this.alterAfterEchartsRendered(isUpdate)
      // }, 200)
      // /* ++++++++++End of 给表格顶部的三餐标签做一个圆角++++++++++ */
      // const { id } = this
      // const ds = this.ds
      if (!isUpdate) {
        this.initChart()
      } else {
        this.updateChart()
      }
    },
    getUiParams() { // 修改配置在这里(数据层面更改后，会修改到这里返回逻辑)
      const { lfw, lfs, ds, setting } = this
      // derror(`ds: ${ds}, lfs: ${lfs}`)
      const uiW = 1754
      // const oneHourW = 34 / uiW * ds // 34是按效果图上的宽
      const oneHourW = 45.35 / uiW * ds
      // const mealLabelOffsetX = (106 / uiW) * ds
      const mealLabelOffsetX = (64 / 12) * lfs
      const mealLabelOffsetH = (34 / 12) * lfs
      // const mealLabelOffsetY = 60.5 - mealLabelOffsetH
      const mealLabelOffsetY = (2 / 12) * lfs
      const mealLabelRoundedCornerW = oneHourW * 3 / 8
      
      const grid = {
        left: (64 / 12) * lfs,
        bottom: lfs * 2,
        top: 0
      }
      grid.right = oneHourW * (45 / 47.19)
      
      const grid2RowTable = {
        left: grid.left,
        right: grid.right,
        top: ((34 + 2) / 12) * lfs,
        bottom: 0
      }
      
      const mealLabelOffsets = { // 会影响到到给矩形的三餐label做圆角的逻辑
        breakfast: {
          what: 'breakfast',
          labelRatio2: 1,
          start: 5, // 5:00开始进食;可以是小数
          duration: 4 // 持续4小时;可以是小数
        },
        lunch: {
          what: 'lunch',
          labelRatio2: 1,
          start: 12, // 12:00开始进食
          duration: 2
        },
        supper: {
          what: 'supper',
          labelRatio2: 1,
          start: 17, // 17:00开始进食
          duration: 5
        }
      }
      
      if (setting && setting.settingId !== undefined) {
        const { breakfastTime, supperTime, lunchTime } = setting
        
        if (breakfastTime) {
          const arr = breakfastTime.split(',')
          const _now = dayjs()
          const startOfDay = _now.startOf('day')
          
          const _start = dayjs(`${_now.format('YYYY-MM-DD')} ${arr[0]}`)
          const _end = dayjs(`${_now.format('YYYY-MM-DD')} ${arr[1]}`)
          const duration = (_end - _start) / (1000 * 60 * 60)
          const start = (_start - startOfDay) / (1000 * 60 * 60)
          
          Object.assign(mealLabelOffsets.breakfast, {
            start, duration
          })
        }
        
        if (lunchTime) {
          const arr = lunchTime.split(',')
          const _now = dayjs()
          const startOfDay = _now.startOf('day')
          
          const _start = dayjs(`${_now.format('YYYY-MM-DD')} ${arr[0]}`)
          const _end = dayjs(`${_now.format('YYYY-MM-DD')} ${arr[1]}`)
          const duration = (_end - _start) / (1000 * 60 * 60)
          const start = (_start - startOfDay) / (1000 * 60 * 60)
          
          Object.assign(mealLabelOffsets.lunch, {
            start, duration
          })
        }
        if (supperTime) {
          const arr = supperTime.split(',')
          const _now = dayjs()
          const startOfDay = _now.startOf('day')
          
          const _start = dayjs(`${_now.format('YYYY-MM-DD')} ${arr[0]}`)
          const _end = dayjs(`${_now.format('YYYY-MM-DD')} ${arr[1]}`)
          const duration = (_end - _start) / (1000 * 60 * 60)
          const start = (_start - startOfDay) / (1000 * 60 * 60)
          
          Object.assign(mealLabelOffsets.supper, {
            start, duration
          })
        }
      }
      
      // // // dev,修改三餐
      // mealLabelOffsets.breakfast.duration = 1
      // mealLabelOffsets.lunch.duration = 1
      // mealLabelOffsets.supper.duration = 1
      // // // End dev,修改三餐
      
      const rst = {
        oneHourW, mealLabelOffsetX, mealLabelOffsetY, mealLabelOffsetH, mealLabelRoundedCornerW, mealLabelOffsets, grid, grid2RowTable
      }
      // derror(`getUiParams mealLabelOffsetY: ${mealLabelOffsetY}`)
      
      // // dev, mock
      // rst.mealLabelOffsets.supper.duration = 0.6
      return rst
    },
    getOptTwoTable(what = '') {
      const { cmax, cmaxC, cmin, cminC, normalC, stripeBgC, stripeInnerBorderC, lfw, lfs, largerRatio, unit, unitRatio, ds, values, isMgUnit, noMealHighlight, lang } = this
      
      const {
        oneHourW, mealLabelOffsetX, mealLabelOffsetY, mealLabelOffsetH, mealLabelRoundedCornerW, mealLabelOffsets, grid2RowTable: grid
      } = this.getUiParams()
      
      const nowT = dayjs()
      const startOfDay = nowT.startOf('day') // 是为了能在dayjs时区变换后能相应体现，所以在这里再次声明一个startOfDay，而不是放到一个全局的地方声明好了，就不动了(复用)  
      const _maxValue = 0
      const _series2Marklines = ([
        {
          silent: true, // 鼠标悬停事件  true没有，false有
          lineStyle: {
            type: 'solid',
            color: stripeInnerBorderC,
            width: 1
          },
          label: {
            show: false,
            position: 'start',
            distance: [6, 0],
            color: cmaxC,
            fontWeigt: lfw
          },
          yAxis: _maxValue // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
        },
        {
          silent: true, // 鼠标悬停事件  true没有，false有
          lineStyle: {
            type: 'solid',
            color: stripeInnerBorderC,
            width: 1
          },
          label: {
            show: false,
            position: 'start',
            distance: [6, 0],
            color: cmaxC,
            fontWeigt: lfw
          },
          yAxis: _maxValue + 1 * unitRatio // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
        },
        {
          silent: true, // 鼠标悬停事件  true没有，false有
          lineStyle: {
            type: 'solid',
            color: stripeInnerBorderC,
            width: 1
          },
          label: {
            show: false,
            position: 'start',
            distance: [6, 0],
            color: cmaxC,
            fontWeigt: lfw
          },
          yAxis: _maxValue + 2 * unitRatio // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
        }
      ])
      
      const _series2 = [
        { // 表格2个横线;table的2个横线
          type: 'line',
          name: 'tableline0',
          symbol: 'none',
          smooth: true,
          markLine: {
            symbol: 'none',
            data: _series2Marklines
          }
        },
        { // 表格的一行数据,第二行(table)
          name: 'tableLine1',
          type: 'line',
          lineStyle: {
            width: 0,
            type: 'solid'
          },
          symbolSize: 0,
          data: _tableLineData(_maxValue + 1 * unitRatio, values, _maxValue, unitRatio),
          label: _tableGetLabelCfg()
        },
        { // 表格table的一行数据,第1行
          name: 'tableLine2',
          type: 'line',
          lineStyle: {
            width: 0,
            type: 'solid'
          },
          symbolSize: 0,
          data: _tableLineData(_maxValue + 2 * unitRatio, values, _maxValue, unitRatio),
          label: _tableGetLabelCfg()
        },
        ...this.getCommonMealBgHighlight()
      ]
      
      const series = _series2
      
      const option = {
        animation: false,
        grid,
        xAxis: this.getCommonXaxis(),
        yAxis: [
          {
            z: 2,
            type: 'value',
            min: 0,
            max: _maxValue + 2 * unitRatio,
            splitNumber: 5,
            nameGap: 15,
            name: unit,
            nameTextStyle: {
              show: true,
              fontWeight: '500',
              fontSize: lfs * (14 / 12),
              color: 'black',
              align: 'center',
              padding: [0, (5 * lfs), (0 - 2 * lfs), 0]
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: stripeInnerBorderC
              }
            },
            splitArea: {
              show: false,
              areaStyle: {
                // 使用深浅的间隔色
                color: ['white', normalC],
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'black',
                width: 1
              },
            },
            axisLabel: {
              margin: 1.4 * lfs,
              show: false,
              showMaxLabel: false,
              color: 'black',
              formatter: (v, i) => {
                if (v - _maxValue >= 0) {
                  return ''
                } else {
                  return `${v}`
                }
              }
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          },
          { // 表格的右边界线
            type: 'value',
            min: 0,
            // max: _maxValue + 2 * unitRatio,
            splitNumber: 5,
            nameGap: 15,
            name: '',
            position: 'right',
            nameTextStyle: {
              show: false
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: stripeInnerBorderC,
                width: 1
              },
            },
            axisLabel: {
              show: false,
              showMaxLabel: false
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          }
        ],
        series
      }
      if (!noMealHighlight) { // 早、中、晚餐的类似label的东西
        // 需要显示三餐高亮
        const { breakfast, lunch, supper } = mealLabelOffsets
        
        const tmps = [breakfast, lunch, supper]
        tmps.forEach(meal => {
          const minDuration = meal.duration
          let labelRatio2 = 1
          if (minDuration !== undefined) {
            if (minDuration - 1.5 >= 0 && minDuration - 2.5 <= 0) { // 包含2
              if (meal.what === 'breakfast') {
                labelRatio2 = 0.9
              }
            } else if (minDuration - 1 >= 0 && minDuration - 1.5 <= 0) {
              labelRatio2 = 0.75
            } else if (minDuration - 1 < 0 && minDuration - 0.5 >= 0) {
              labelRatio2 = 0.4
            } else if (minDuration - 0.5 < 0 && minDuration > 0) {
              labelRatio2 = 0.3
            }
          }
          
          // 字体再特殊化缩小
          /* eslint-disable */
          switch(`${lang}`) {
          case 'es':
            labelRatio2 *= 0.8          
            if (minDuration - 1.5 < 0) {
              labelRatio2 *= 0.66
            }
            break
          case 'de':
            labelRatio2 *= 0.7
            if (minDuration - 1.5 < 0) {
              labelRatio2 *= 0.64
            }
            break
          case 'pt-br': // 葡萄牙语-巴西
            if (meal.what === 'breakfast') {
              if (minDuration - 1.5 < 0) {
                labelRatio2 *= 0.4
              } else if (minDuration - 1.5 >= 0 && minDuration - 2 <= 0) {
                labelRatio2 *= 0.68
              }
            }

            if (meal.what === 'lunch' && minDuration - 1.5 < 0) {
              labelRatio2 *= 0.8
            }
            break
          case 'bg':
          case 'sl': // 斯洛文尼亚
          case 'sk': // 斯洛伐克
          case 'hr': // 克罗地亚
          case 'it':
          case 'el': // 希腊语
              if (meal.what === 'lunch' && (minDuration - 2.5 < 0)) {
                labelRatio2 *= 0.7
              }
            break
          case 'pl':
          case 'ru':
            default:
            labelRatio2 *= 0.8
            if (meal.what === 'breakfast' && minDuration - 1.5 < 0) {
              labelRatio2 *= 0.85
            }
            break
          }
          /* eslint-enable */
          
          Object.assign(meal, {
            labelRatio2
          })
        })

        option.graphic = [
          {
            type: 'group',
            id: 'breakfast_label',
            bounding: 'all',
            top: mealLabelOffsetY,
            left: breakfast.start * oneHourW + mealLabelOffsetX,
            z: 100,
            children: [              
              {
                type: 'rect',
                left: 'center',
                top: 'center',
                z: 100,
                id: 'label_1',
                shape: {
                  width: oneHourW * breakfast.duration,
                  height: mealLabelOffsetH
                },
                style: {
                  fill: cmaxC
                }
              },
              {
                type: 'text',
                left: 'center',
                top: 'center',
                id: 'label_text',
                z: 100,
                style: {
                  fill: '#fff',
                  text: this.$t('Breakfast'),
                  font: `bold ${lfs * largerRatio * breakfast.labelRatio2}px sans-serif`
                }
              }
            ]
          },
          {
            type: 'group',
            bounding: 'all',
            top: mealLabelOffsetY,
            left: lunch.start * oneHourW + mealLabelOffsetX,
            z: 100,
            children: [
              {
                type: 'rect',
                left: 'center',
                top: 'center',
                z: 100,
                shape: {
                  width: oneHourW * lunch.duration,
                  height: mealLabelOffsetH
                },
                style: {
                  fill: cmaxC
                }
              },
              {
                type: 'text',
                left: 'center',
                top: 'center',
                z: 100,
                style: {
                  fill: '#fff',
                  text: this.$t('Lunch'),
                  font: `bold ${lfs * largerRatio * lunch.labelRatio2}px sans-serif`
                }
              }
            ]
          },
          {
            type: 'group',
            bounding: 'all',
            top: mealLabelOffsetY,
            left: supper.start * oneHourW + mealLabelOffsetX,
            z: 100,
            children: [
              {
                type: 'rect',
                left: 'center',
                top: 'center',
                z: 100,
                shape: {
                  width: oneHourW * supper.duration,
                  height: mealLabelOffsetH
                },
                style: {
                  fill: cmaxC
                }
              },
              {
                type: 'text',
                left: 'center',
                top: 'center',
                z: 100,
                style: {
                  fill: '#fff',
                  text: this.$t('Supper'),
                  font: `bold ${lfs * largerRatio * supper.labelRatio2}px sans-serif`
                }
              }
            ]
          }
        ]
      }
      
      derror(`ChartGluTable, getOptTwoTable option`, option)
      return option
      
      function _tableLabelFormatter(params = {}) {
        const { data = [] } = params
        // derror(`formatter, v: ${JSON.stringify(v)}, params: ${params}`)
        const v = data[2]
        
        // if (!(v === undefined || v === null)) {
        if (v) {
          let v2 = v
          if (isMgUnit) {
            v2 = (+v2).toFixed(0)
          }
          const str = `${v2}`
          const l = str.length
          /* eslint-disable*/
          return `${str}`
          // switch(l) {
          // case 4:
          //   return `${str}`
          // case 2:
          //   return `  ${str}`
          // case 1:
          //   return `   ${str}`
          // default:
          //   return ` ${str}`
          // }
          /* eslint-enable*/
        } else {
          return ''
        }
      }
      
      function _tableGetLabelCfg() {
        const rst = {
          show: true,
          position: 'bottom',
          distance: 0,
          color: '#3D3D3D',
          fontSize: lfs,
          offset: [0, lfs / 2],
          formatter: _tableLabelFormatter
        }
        return rst
      }
    },
    getOpt(what = '') {
      const { cmax, cmaxC, cmin, cminC, normalC, stripeBgC, stripeInnerBorderC, lfw, lfs, largerRatio, unit, unitRatio, ds, values, noHorizontalSplitLine } = this
      
      const _maxValue = Math.ceil(values.reduce((prev, cur) => {
        if (cur && (cur.bloodGlucose - prev > 0)) {
          return +cur.bloodGlucose
        } else {
          return prev
        }
      }, 0))
      derror(`_maxValue: ${_maxValue}`)
      
      const {
        oneHourW, mealLabelOffsetX, mealLabelOffsetY, mealLabelOffsetH, mealLabelRoundedCornerW, mealLabelOffsets, grid
      } = this.getUiParams()    
      
      const nowT = dayjs()
      const startOfDay = nowT.startOf('day') // 是为了能在dayjs时区变换后能相应体现，所以在这里再次声明一个startOfDay，而不是放到一个全局的地方声明好了，就不动了(复用)  
      
      let series = this.getSeriesFromDataSource(what).concat(this.getCommonMealBgHighlight())
      
      if (what !== 'initChart') {
        // 插入高低血糖横线
        series = series.concat({ // 高低血糖的境界的横线
          type: 'line',
          data: [],
          lineStyle: {
            width: 2
          },
          symbol: 'none',
          smooth: true,
          markLine: {
            symbol: 'none',
            data: [
              {
                silent: true, // 鼠标悬停事件  true没有，false有
                lineStyle: {
                  type: 'dashed',
                  color: cmaxC,
                  width: 1
                },
                label: {
                  show: true,
                  position: 'start',
                  distance: [6, 0],
                  color: cmaxC,
                  fontWeigt: lfw
                },
                yAxis: cmax // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
              },
              {
                silent: true, // 鼠标悬停事件  true没有，false有
                lineStyle: {
                  type: 'dashed',
                  color: cminC,
                  width: 1
                },
                label: {
                  show: true,
                  position: 'start',
                  distance: [6, 0],
                  color: cminC,
                  fontWeigt: lfw
                },
                yAxis: cmin
              }
            ]
          },
          markArea: { // 高亮高低血糖中间
            itemStyle: {
              color: 'rgba(187, 234, 139, 0.20)',
              borderColor: '#abccba',
              borderWidth: 0
            },
            data: [
              [{ yAxis: cmin }, { yAxis: cmax }]
            ]
          }
        })
      }
      
      const xAxis = [...this.getCommonXaxis('bottom')]
      if (noHorizontalSplitLine) { // 画一个顶部的线，从而有border效果
        xAxis.push({
          type: 'time',
          position: 'top',
          splitLine: {
            show: false
          },
          axisLine: {
            onZero: false, // 默认是true,会导致position: top无效，一直显示在底部
            show: true,
            lineStyle: {
              color: stripeInnerBorderC
            },
          },
          axisLabel: {
            show: false,
            showMaxLabel: false
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: 'red'
            }
          },
          minorTick: {
            show: false
          }
        })
      }
      const option = {
        animation: false,
        grid,
        xAxis,
        yAxis: [
          {
            z: 2,
            type: 'value',
            min: 0,
            splitNumber: 5,
            nameGap: 15,
            name: unit,
            nameTextStyle: {
              fontWeight: '500',
              // fontSize: lfs * (14 / 12),
              fontSize: 0,
              color: 'black',
              align: 'center',
              padding: [0, (5 * lfs), (0 - 2 * lfs), 0]
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: !noHorizontalSplitLine,
              lineStyle: {
                color: stripeInnerBorderC
              }
            },
            splitArea: {
              show: false,
              areaStyle: {
                // 使用深浅的间隔色
                color: ['white', normalC],
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'black',
                width: 1
              },
            },
            axisLabel: {
              margin: 1.4 * lfs,
              show: true,
              showMaxLabel: true,
              color: 'black',
              formatter: (v, i) => {
                if (i - 5 >= 0) { // 最上面一行，文字要偏移一下，否则会被截断
                  return `
${v}`
                } else {
                  return `${v}`
                }
              }
            },
            axisTick: {
              show: true, // 不显示刻度
            }
          },
          { // 表格的右边界线
            type: 'value',
            min: 0,
            // max: _maxValue + 2 * unitRatio,
            splitNumber: 5,
            nameGap: 15,
            name: '',
            position: 'right',
            nameTextStyle: {
              show: false
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: stripeInnerBorderC,
                width: 1
              },
            },
            axisLabel: {
              show: false,
              showMaxLabel: false
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          }
        ],
        series
      }
      derror(`ChartGluTable, option`, option)
      return option
    },
    initChart() {
      const { id } = this
      const canvasid = `wtgluTable_${id}`
      const canvasid2 = `wtgluTable_2_${id}`
      try {
        const myChart = this.$echarts.init(document.getElementById(`${canvasid}`), null, { renderer: 'svg' })
        const opt = this.getOpt('initChart')
        
        myChart.on('finished', () => {
          this.alterAfterEchartsRendered(false) // 画底部两个圆角
        })
        
        myChart.setOption(opt)
        
        const myChart2 = this.$echarts.init(document.getElementById(`${canvasid2}`), null, { renderer: 'svg' })
        const opt2 = this.getOptTwoTable('initChart')
        
        myChart2.on('finished', () => {
          this.alterAfterEchartsRendered2RowTable(false) // 画头部2个圆角；三餐的top的2个圆角
        })
        
        myChart2.setOption(opt2)
        
        this._myCharts = [myChart, myChart2]
      } catch (err) {
        error('被捕获:' + err)
      }
    },
    updateChart() {
      log(`updateChart, values: ${this.values}`)
      derror(`要注意echart图表更新后，我之前添加的diamond的path，是否依然在svg里头不再里头的话会容易出错，得修改逻辑`)
      const myChart = this._myCharts[0]
      const newOpt = this.getOpt('updateChart')
      const myChart2 = this._myCharts[1]
      const newOpt2 = this.getOptTwoTable('updateChart')
      
      this.$nextTick(() => {
        try {
          if (myChart) {
            myChart.setOption(newOpt)            
          }
          if (myChart2) {
            myChart2.setOption(newOpt2)            
          }
        } catch (err) {
          error('被捕获:' + err)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables';

$pl: $sizePaddingTopLegend;
.gluTable-ctn {
    display: inline-block;
}
.legend {
    margin-top: $pl * 0.7;
    margin-left: $pl * 2;
    &.legend--row2 {
        margin-top: $pl;
        margin-bottom: $pl + 4px;
    }
    ::v-deep > .wtLegend-ctn {
        margin-left: $pl;
        .wtLegend--icon .svg-icon {
            display: inline-block;
            $w: $sizeLegendSvgIconWidth;
            width: $w;
            height: $w;
        }
        &.legend-diamondCtn {
            .wtLegend--icon .svg-icon {
                display: inline-block;
                $w: $sizeLegendSvgIconWidth--diamond;
                width: $w;
                height: $w;
            }            
        }
        &:first-child {
            margin-left: 0;
        }
    }
}
</style>
